module.exports = __webpack_public_path__ + "img/ad-login.b1a8532e.svg";